import { useQuery } from '@tanstack/react-query'

import { getUnmatchedCardTransactions } from '@/api/services/card-transaction'

/** その日のカード利用のうち、レシートが無いもの */
export const useUnmatchedCardTransactions = (date: string, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['card-transactions', 'unmatched', date],
    queryFn: ({ signal }) => getUnmatchedCardTransactions(date, signal),
    enabled: options?.enabled ?? true,
  })
